import React, {useState} from 'react'
import {toaster} from '../../../shared/PFToast'
import {FRAGMENT_DETECTION} from '../../../constant/fragmentDetection'

/**
 * FragmentWarning - Displays warning notifications for detected fragments
 * @param {Object} props
 * @param {Array} props.fragments - Array of fragment objects
 * @param {boolean} props.autoShow - Whether to auto-show warning on mount
 * @param {Function} props.onDismiss - Callback when warning is dismissed
 */
const FragmentWarning = ({fragments = [], autoShow = true, onDismiss}) => {
    const [dismissed, setDismissed] = useState(false)

    React.useEffect(() => {
        if (autoShow && fragments.length > 0 && !dismissed) {
            showWarning()
        }
    }, [fragments, autoShow, dismissed])

    const showWarning = () => {
        const totalArea = fragments.reduce((sum, f) => sum + f.area, 0)
        const message = `Phát hiện ${fragments.length} fragment nhỏ (tổng ${Math.round(totalArea)} pixels). Có thể ảnh hưởng đến chất lượng in ấn.`

        toaster({
            type: 'warning',
            message,
            duration: 8000,
            action: {
                label: 'Đóng',
                onClick: handleDismiss
            }
        })
    }

    const handleDismiss = () => {
        setDismissed(true)
        if (onDismiss) {
            onDismiss()
        }
    }

    // Return null - component only shows toast notifications
    return null
}

/**
 * Show fragment warning programmatically
 * @param {Array} fragments
 */
export function showFragmentWarning(fragments) {
    if (!fragments || fragments.length === 0) return

    const totalArea = fragments.reduce((sum, f) => sum + f.area, 0)
    const message = `Phát hiện ${fragments.length} fragment nhỏ (tổng ${Math.round(totalArea)} pixels). Có thể ảnh hưởng đến chất lượng in ấn.`

    toaster({
        type: 'warning',
        message,
        duration: 8000
    })
}

export default FragmentWarning

